'use client';

import {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import {X} from 'lucide-react';
import {useCloseOnEscape} from 'common/hooks/close_on_escape';
import {useMobileRedirectModal} from 'common/hooks/mobile_redirect_modal';
import {ShareFlow} from 'iq-takehomes/components/share_flow';

type Props = {
  onClose: () => void;
  onSuccess?: () => void;
  continueLabel?: string;
};

export function ShareTakeHomeModal({onClose, onSuccess, continueLabel}: Props) {
  const [shared, setShared] = useState(false);
  const handleSuccess = onSuccess ?? onClose;
  // Once the share completes the quota changed, so any dismissal (X, Escape,
  // backdrop) must refresh — not just the success-screen button.
  const dismiss = shared ? handleSuccess : onClose;

  const mounted = useMobileRedirectModal('/takehomes/submit', onClose);

  useCloseOnEscape(dismiss);

  // TODO: review this!
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!mounted) return null;

  return createPortal(
    <div
      className='fixed inset-0 flex items-center justify-center p-4'
      style={{zIndex: 1000}}
      aria-modal='true'
      role='dialog'>
      <div className='absolute inset-0 bg-black/60 animate-modal-backdrop' onClick={dismiss} />

      <div className='relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl animate-modal-panel max-h-[90vh] overflow-y-auto'>
        <button
          onClick={dismiss}
          className='absolute top-4 right-4 z-10 text-iq-grey-medium hover:text-iq-grey-dark transition-colors'
          aria-label='Close'>
          <X className='w-5 h-5' />
        </button>

        <ShareFlow
          compact
          onSuccess={handleSuccess}
          onShared={() => setShared(true)}
          continueLabel={continueLabel}
        />
      </div>
    </div>,
    document.body,
  );
}
